export const isMobile = /^1\d{10}$/
export const isHKMobile = /(^([1-9])\d{7}$)|(^([1-9])\d{9}$)/
export const isMacaoMobile = /^6\d{7}$/
export const isTaiwanMobile = /^[0][9]\d{8}$/

export const isTradePwd = /^\d{6}$/

export const isIdCard =
  /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/

export const isURL = /^https?:\/\//

export const isAmount = /^(\d+)(.\d{0,2})?$/

/** 描述词根据符号分片reg */
export const isWordBetweenSymbol =
  /[^\.\,\;\。\，\；\(\)\{\}\（\）]+?(?=[\.\,\;\。\，\；\(\)\{\}\（\）])/g
/** 描述词特殊字符reg */
export const isSpecialSymbol = new RegExp(
  "[\"`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥…&*（）—|{}【】‘；：”“'。，、？]",
  'g'
)

/** jpg格式图片 */
export const isJpgReg = /.*\.jpg($|\?)/i
/** png格式图片 */
export const isPngReg = /.*\.png($|\?)/i
